/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { BaseApiClient, RequestContext, ApiConfigManager, HttpRequestState } from '@sg/api/base-api-lib';
import { CurrenciesApiConfig } from '../api-config';

import { CurrenciesApi } from '../models';

@Injectable()
export class CurrenciesApiClient extends BaseApiClient<CurrenciesApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.currenciesApiConfig);
  }

  currenciesControllerPostCurrenciesSearch(
    params?: {
      body?: CurrenciesApi.CurrenciesSearchRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrencyCode';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<CurrenciesApi.CurrencyDtoCurrenciesSortCriteriaDtoPagingResultDto>;
  currenciesControllerPostCurrenciesSearch(
    params?: {
      body?: CurrenciesApi.CurrenciesSearchRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrencyCode';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<CurrenciesApi.CurrencyDtoCurrenciesSortCriteriaDtoPagingResultDto>>;
  currenciesControllerPostCurrenciesSearch(
    params?: {
      body?: CurrenciesApi.CurrenciesSearchRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrencyCode';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<CurrenciesApi.CurrencyDtoCurrenciesSortCriteriaDtoPagingResultDto>;
  currenciesControllerPostCurrenciesSearch(
    params?: {
      body?: CurrenciesApi.CurrenciesSearchRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrencyCode';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<CurrenciesApi.CurrencyDtoCurrenciesSortCriteriaDtoPagingResultDto>>;
  currenciesControllerPostCurrenciesSearch(
    params?: {
      body?: CurrenciesApi.CurrenciesSearchRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrencyCode';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<CurrenciesApi.CurrencyDtoCurrenciesSortCriteriaDtoPagingResultDto>>;
  currenciesControllerPostCurrenciesSearch(
    params?: {
      body?: CurrenciesApi.CurrenciesSearchRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrencyCode';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<CurrenciesApi.CurrencyDtoCurrenciesSortCriteriaDtoPagingResultDto>>;
  currenciesControllerPostCurrenciesSearch(
    params?: {
      body?: CurrenciesApi.CurrenciesSearchRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrencyCode';
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'pageSize', params.pageSize],
        ['', 'pageNumber', params.pageNumber],
        ['', 'sortDirection', params.sortDirection],
        ['', 'orderBy', params.orderBy]
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<CurrenciesApi.CurrencyDtoCurrenciesSortCriteriaDtoPagingResultDto>(
      `${this.basePath}/gateway/admin/currencies/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
